<template><svg width="32" height="32" viewBox="0 0 32 32"  xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6497 26H13.2157V16.4988H11V13.225H13.2157V11.2595C13.2157 8.58893 14.4661 7 18.0209 7H20.9797V10.275H19.1305C17.7466 10.275 17.6552 10.7325 17.6552 11.5863L17.6491 13.225H21L20.6078 16.4988H17.6491V26H17.6497Z"  />
</svg>
</template>